import { type InputNumberProps, InputNumber as OriginInputNumber } from "antd"
import React from "react"

import { limitNumericInput } from "../../utils/number/limit-numeric-input.ts"

const formatter = (
  value: number | string | undefined,
  info: { userTyping: boolean; input: string },
  precision?: number,
  maxDigits?: number,
  maxIntegerDigits?: number
): string => {
  if (value === undefined || value === null || value === "") return ""

  if (info.userTyping) {
    return limitNumericInput(info.input, maxDigits, maxIntegerDigits)
  }

  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: precision ?? 2,
    notation: "standard",
    compactDisplay: "short"
  }).format(+value)
}

const parser: InputNumberProps<number>["parser"] = (value) => {
  if (!value?.trim()) return null as unknown as number
  return value.replace(/\$\s?|(,*)/g, "") as unknown as number
}

type InputNumberNewProps = Omit<
  InputNumberProps<number>,
  "formatter" | "parser"
> & {
  maxDigits?: number
  maxIntegerDigits?: number
}

export const InputNumber = React.forwardRef<
  React.ComponentRef<typeof OriginInputNumber>,
  InputNumberNewProps
>(({ maxDigits, maxIntegerDigits, ...props }, ref) => {
  return (
    <OriginInputNumber
      ref={ref}
      parser={parser}
      formatter={(...args) =>
        formatter(
          args[0],
          args[1],
          props?.precision,
          maxDigits,
          maxIntegerDigits
        )
      }
      {...props}
    />
  )
})

InputNumber.displayName = "InputNumberNew"

export default InputNumber
